import React from 'react'
import styled from 'styled-components/macro'
import { Message } from './Message'
import { MessageType } from './Message.constants'

// Show All / Hide, shared so every surface that offers to widen a date-bounded list reads
// the same. Out-of-window evidence was the first; importable control tests are the second.
export const OUT_OF_RANGE_SHOW_ALL_LABEL = 'Show All'
export const OUT_OF_RANGE_HIDE_LABEL = 'Hide'

const NoticeContainer = styled.div<{ $inset?: boolean }>`
  margin-bottom: 16px;
  // $inset matches GridContainer's horizontal padding, for surfaces that render the notice
  // outside one. Inside a GridContainer it is already aligned, so padding it would push it
  // in twice.
  ${({ $inset }) => $inset && `padding: 0 24px;`}
`

// OutOfRangeNotice states how much a date range is holding back and offers to reveal it.
//
// Presentation only: the caller owns the count, the toggle state and where the toggle lives
// — the URL on an index page, local state inside a modal.
//
// Deliberately no dismiss: the notice explains why the list below is short, and dismissing
// it would leave a list that silently omits rows.
export const OutOfRangeNotice = ({
  messageText,
  isShowingAll,
  onToggle,
  inset = false,
}: {
  messageText: string
  isShowingAll: boolean
  onToggle: () => void
  inset?: boolean
}): JSX.Element => (
  <NoticeContainer $inset={inset}>
    <Message
      messageType={MessageType.WARNING}
      messageText={messageText}
      ctaButton={{
        text: isShowingAll
          ? OUT_OF_RANGE_HIDE_LABEL
          : OUT_OF_RANGE_SHOW_ALL_LABEL,
        onClick: onToggle,
        withMargin: true,
      }}
    />
  </NoticeContainer>
)
